
























import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import type { SubBrand, Theme } from '@/store/modules/themes';
import { Modules } from '@/store/store';
import { namespace } from 'vuex-class';
import { BoundingBox } from '@/store/modules/config';

const themeModule = namespace(Modules.themes);
const configModule = namespace(Modules.config);

@Component({ name: 'eqweb-tooltip-info-dot' })
export default class TooltipInfoDot extends Vue {
  @Prop()
  label!: string;

  @Prop()
  text!: string;

  @themeModule.Getter('propsTheme')
  private readonly theme!: Theme;

  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  @configModule.Getter('asSidebar')
  private readonly asSidebar!: boolean;

  @configModule.Getter('appBoundingBox')
  private readonly appBoundingBox!: BoundingBox;

  private get sanitizedLabel(): string | undefined {
    const l = this.label?.trim()?.replace(/\s+/g, '-')?.toLowerCase();
    return l && `tt_${l}-info`;
  }

  // only set and overwrite wb max-width for tooltip when in sidebar mode
  private get cssVariables() {
    const tooltipMaxWidth = (this.appBoundingBox?.width || 250) - 50;
    if (this.asSidebar) {
      return { '--tooltip-max-width': tooltipMaxWidth + 'px' };
    }
    return {};
  }
}
